import { ButtonEx } from '@xylabs/sdk-react'
import React from 'react'
import { useLocation } from 'react-router-dom'

const JsonButton: React.FC = () => {
  const { pathname } = useLocation()
  return (
    <ButtonEx to={`${pathname}/json`} variant="outlined">
      Json
    </ButtonEx>
  )
}

export default JsonButton
